module.exports = __webpack_public_path__ + "static/9-6801e1c3dd01742185219ce8e1f53dad.png";